<template>
  <div class="accent">
    <v-container fluid class="pa-3 pa-md-4">
      <app-action-panel />
    </v-container>
  </div>
</template>

<script>
export default {
  components: {
    appActionPanel: () => import('@/components/assessment-center/actionPanel'),
  },
  props: {
    source: String,
  },
}
</script>
